import { render } from "./GroupTravelers.vue?vue&type=template&id=be8da2fe"
import script from "./GroupTravelers.vue?vue&type=script&lang=js"
export * from "./GroupTravelers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__